<template>
    <div id="stational_monitor">
        <Operations></Operations>
        <div class="ui divider"></div>
        <CoreWaybillsUnderOperations></CoreWaybillsUnderOperations>
    </div>
</template>

<script>
import Operations from "../.components/stational/operations/index.vue"
import CoreWaybillsUnderOperations from "../.components/stational/core_waybills_under_operations/index.vue"

export default {
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    },
    methods: {
    },
    components: {
        Operations,
        CoreWaybillsUnderOperations,
    }
}
</script>
<style scoped>
</style>
